import React from "react";
import CheckBox from "../../../../core-components/Checkbox/Checkbox";
import * as S from "./SpecialRequest.styles";

interface ISpecialRequest {
  msg: string;
  opt: Array<{
    t: string;
    options: Array<{
      t: string;
      options: Array<{ t: string; icon: string }>;
    }>;
  }>;
  updateSelectedData?: Function;
  sr: Array<[]>;
}

const SpecialRequestUI: React.FC<ISpecialRequest> = ({
  msg = "",
  opt = [],
  updateSelectedData = () => {},
  sr = [],
}) => {
  const onUpdate = ({ fc, oc, checked }) => {
    const newSR = JSON.parse(JSON.stringify(sr));
    if (!sr?.length) {
      newSR.push({ fc, opt_code: [oc] });
    } else {
      let isFound = 0;
      newSR.forEach((data, index) => {
        if (data["fc"] === fc) {
          isFound++;
          if (checked) {
            newSR[index].opt_code.push(oc);
          } else {
            if (newSR[index].opt_code.indexOf(oc) > -1) {
              if (newSR[index].opt_code.length === 1) {
                newSR.splice(index, 1);
              } else {
                newSR[index].opt_code.splice(
                  newSR[index].opt_code.indexOf(oc),
                  1
                );
              }
            }
          }
        }
      });
      if (!isFound) {
        newSR.push({ fc, opt_code: [oc] });
      }
    }
    console.info("newSR", newSR, checked);
    updateSelectedData({ s_r: newSR });
  };
  return (
    <S.SplReq>
      <h4>{"Special request (optional)"}</h4>
      {msg ? <h5>{msg}</h5> : null}
      {opt?.length ? (
        <div className="splReq__row">
          {opt.map(({ options = [], t = "", fc }, index) => (
            <div key={`splReq__row${index}`}>
              <h6>{t}</h6>
              {options?.length ? (
                <ul className="splReq__list">
                  {options.map(({ t = "", icon = "", oc = "" }, index) => {
                    const checked = sr?.some(
                      ({ fc: filterCode, opt_code }) =>
                        filterCode === fc && opt_code?.indexOf(oc) > -1
                    );
                    return (
                      <li key={`splReq__list${index}`}>
                        <CheckBox
                          title={t}
                          name={icon}
                          isIcon={!!icon}
                          onClickCb={() => {}}
                          checked={checked}
                          onClickCb={onUpdate}
                          data={{ fc, oc, checked: !checked }}
                        />
                      </li>
                    );
                  })}
                </ul>
              ) : null}
            </div>
          ))}
        </div>
      ) : null}
    </S.SplReq>
  );
};

export default React.memo(SpecialRequestUI);
